// Registro dos ícones do kit (F8 normaliza os 42 SVGs para currentColor em src/brand/icons/). Fechado: nome fora do set não compila.
const registry = import.meta.glob('./icons/*.svg', { query: '?raw', import: 'default', eager: true }) as Record<string, string>
export const byName: Record<string, string> = Object.fromEntries(Object.entries(registry).map(([p, svg]) => [p.replace(/^.*\/(.+)\.svg$/, '$1'), svg]))
export const iconNames = Object.keys(byName).sort() as readonly string[]
export type IconName = (typeof iconNames)[number]
